<ng-container
  *ngIf="collectionsService.collections.length < 1 && !fetching; else content"
>
  <kor-empty-state
    label="you haven't created any collections yet"
    icon="url(assets/imgs/collections.png)"
  >
    <kor-button
      slot="footer"
      label="create collection"
      (click)="
        userService.user
          ? (editCollectionModalVisible = true)
          : (userService.authModalVisible = true)
      "
    ></kor-button>
  </kor-empty-state>
</ng-container>

<ng-template #content>
  <kor-grid columns="4">
    <kor-card class="cta" (click)="editCollectionModalVisible = true">
      <kor-empty-state
        label="create collection"
        icon="url(assets/imgs/collections.png)"
      ></kor-empty-state>
    </kor-card>
    <kor-card
      *ngFor="let collection of collectionsService.collections"
      routerLink="/collection/{{ collection.uid }}"
    >
      <h3>{{ collection.name }}</h3>
      <br />
      <p>
        {{ collection.pages.length }} pages
        <br />
        modified at {{ (collection.modifiedAt.toDate() | date).toLowerCase() }}
      </p>
    </kor-card>
  </kor-grid>
</ng-template>

<!-- create collection modal -->
<app-edit-collection-modal
  *ngIf="editCollectionModalVisible"
  (close)="editCollectionModalVisible = false"
  (save)="collectionsService.setCollection($event)"
></app-edit-collection-modal>
